<template>
<div class="row row-cols-1 gy-4 gx-3 px-3 ps-0 pe-0 " >
  <div class="col-md-6 col-sm-1 middle-col margin-small">
    <ul class="characteristics text-white text-start" style="font-size: calc(1rem + 0.2vw);">
      <li>Бренд<span class="value">AddGrill</span></li>
      <li class="spacing-text">Название модели<span class="value">Ростер для 7 перепёлок</span></li>
      <li class="spacing-text">Страна-изготовитель<span class="value">Россия</span></li>
    </ul>
  </div>
  <div class="col-md-5 col-sm-1 middle-col margin-small w-text-screen offset-md-1 offset-lg-2 offset-xl-2">
    <ul class="characteristics text-white text-start" style="font-size: calc(1rem + 0.2vw);">
      <li>Тип<span class="value">Подставка для перепёлок</span></li>
      <li class="spacing-text">Размеры<span class="value">210х210х115 мм</span></li>
      <li class="spacing-text">Можно мыть в посудомойке<span class="value">Да</span></li>
    </ul>
  </div>
</div>
</template>
<style scoped lang="scss">
.spacing-text{
  margin-top : 1rem!important;
}
@media (max-width: 600px) {
.margin-small{
  padding: 2%!important;
}
}
@media (max-width: 849px) and (min-width: 601px) {
  .margin-small{
    padding: 0%!important;
  }
}
@media (min-width: 950px) and (max-width: 1799px) {
  .middle-col{
    flex:0 0 auto;
    width:41.66666667%!important;
  }
}
@media (min-width: 1800px) {
  .middle-col{
    flex:0 0 auto;
    width:33.33333333%!important;
  }
}
.characteristics {
padding: 0; /* Убираем отступы */
}
.characteristics li {
align-items: baseline; /* Выравниваем текст */
display: flex; /* Включаем флексы */
margin-bottom: 0.5em; /* Отступ снизу */
}
.characteristics li::before {
content: ''; /* Выводим линию */
border-bottom: 1px dashed #ccc; /* Параметры линии */
flex-grow: 1; /* Линия занимает всё доступное пространство */
order: 2; /* Выводим вторым */
margin: 0 5px; /* Расстояние от текста */
}
.characteristics .value {
order: 3; /* Выводим третьим */
}
</style>